<template>
  
  <v-container fluid>

    <v-layout row my-1>
      <v-flex xs12 class="text-xs-center">
        <h3>Member Perks</h3>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap>
      <v-flex xs12 my-1 class="text-xs-center mt-3">
        <span class="body-1">Make the most of your membership by taking advantage of these amazing deals from our partners, exclusively for TRVL Porter clients</span>
      </v-flex>
    </v-layout>

    <v-layout row wrap my-5>
      <v-flex xs12 style="border: 2px solid #000;" py-5 class="text-xs-center" :class="{'px-5':$vuetify.breakpoint.mdAndUp, 'px-4':$vuetify.breakpoint.smAndDown}">
        <div>
          <img :src="cdn + 'logo_DUFL.png'" style="max-width: 200px;">
        </div>
        <div class="text-xs-left mt-4" :class="{'px-5':$vuetify.breakpoint.mdAndUp}">
          A premium travel service that simplifies travel by shipping, cleaning and storing your attire. DUFL saves travelers 3-5 hours per round trip and with the help of Trvl Porter's rental travel wardrobe. DUFL eliminates all the stress of packing, unpacking, doing laundry and dragging a bag through the airport.
          <br><br>
          Sign up for DUFL using the promo code TRVLPORTER to receive your first DUFL trip FREE ($99 value)!
        </div>
        <div class="mt-4">
          <v-btn color="black" dark href="http://lp.dufl.com/trvlporter" target="_blank">Redeem</v-btn>
        </div>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>

export default {
  name: 'AccountPerks',
  data () {
    return {}
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    
  }
}
</script>
